import React, { useState } from 'react'
import send from "../../../assets/img/icons/send-2.svg"
import nowishlist from "../../../assets/img/dashboard/nowishlist.svg"
import PlaceCard from '../../common/PlaceCard'
import useFetch from '../../../hooks/useAxios'



const WishList = () => {
  const [wishListInfo, setWishlistInfo] = useState([])
  const fetchWishlist = useFetch({
    method: "get",
    url: "api/wishlist",
    noHeader: false,
    trigger: true,
    argFunc: res => {
      setWishlistInfo(res.data.wishlist)
      
    }
  });

  return (
    <div className='WishList'>
        <div className='d-flex-space'>
            <h3>
            لیست علاقه مندی ها
            </h3>
        <div className='send-box mr-[16px]'>
                <img src={send} />
                <p className='mr-[8px]'>اشتراک گذاری کردن</p>

            </div>
        </div>
        <hr className='mt-[30px] mb-[50px]'/>
        {wishListInfo.length > 0 ?<div className='WishList--grid'>
       { wishListInfo.map(i=>
           <PlaceCard  img={`${i.thumbnail.path}`}
                      isfast={i.instant_reserve === 1 ? true : false}
                      rate={i.rating_value}
                      info={i.address}
                      title={i.title}
                      key={i.id}
                      cost={i.price}
                      tip={i.special_discount_in_24}
                      code={i.code}
                      slug={i.slug}
                      wishlist={i.wishlist}
                      id={i.id}
                      room={i.rooms_count}
                      city={i.city}
                      type={i.type} />) }
            
       </div>
        :<div className='nowishlist center-column'>

               <img src={nowishlist}/>
               <h6>هنوز اقامتگاهی به لیست اضافه نکردید !</h6> 
            </div>}
 
    </div>
  )
}

export default WishList